// removed by extract-text-webpack-plugin
module.exports = {"finalPriceWrap":"qempo_ButtonGreyBox_finalPriceWrap-1DFluHD"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/ButtonGreyBox/ButtonGreyBox.scss
// module id = 1356
// module chunks = 0